export const bussineValidation = "Error : No se valido correctamente: Error -1 al timbrar: 'El campo Nombre del receptor, debe pertenecer al nombre asociado al RFC registrado en el campo Rfc del Receptor.'"

export const bussinePatient =
    "La razón social no coincide con el RFC registrado ante el SAT. Verifica que la razón social esté escrita exactamente como aparece en tu Constancia de Situación Fiscal.";

export const rfcValidation =
    "Error : No se valido correctamente: Error -1 al timbrar: 'Este RFC del receptor no existe en la lista de RFC inscritos no cancelados del SAT'";

export const rfcPatient =
    "El RFC ingresado no está registrado como vigente ante el SAT. Verifica que el RFC esté escrito correctamente y que corresponda al receptor de la factura.";

export const cpValidation =
    "Error : No se valido correctamente: Error -1 al timbrar: 'El campo DomicilioFiscalReceptor del receptor, debe pertenecer al nombre asociado al RFC registrado en el campo Rfc del Receptor.'";

export const cpPatient =
    "El código postal ingresado no coincide con los datos registrados ante el SAT para este RFC. Verifica que sea el código postal de tu domicilio fiscal registrado en tu Constancia de Situación Fiscal.";
